import { Box, Grid }          from '@mui/material';
import React, { FC }          from 'react';
import { GridDivider }        from '../../../../../../shared/components/layout/GridDivider';
import { filterMembersById }  from '../../../../../../shared/functions';
import { FlexEndGrid }        from '../../../../../../shared/styledComponents';
import { IFamilyMember }      from '../../../../../../shared/utils/withAuthorization/withAuthorization';
import { FamilyMembersList }  from '../../../../../Dashboard/components/FamilyMembers/FamilyMembersList';
import { ITaggedItem }        from '../shared';
import { MemberDetails }      from './MemberDetails';
import { TaggedItemControls } from './TaggedItemContols';

interface ITaggedItemRowProps {
  data: ITaggedItem;
  last?: boolean;
  isAssignees?: boolean;
  familyMembers?: IFamilyMember[];

  onRemove(id: string): void;

  onView(): void;
}

export const TaggedItemRow: FC<ITaggedItemRowProps> = ({
  data,
  last,
  isAssignees,
  familyMembers,
  onRemove,
  onView,
}) => {
  const ItemsActions = (
    <TaggedItemControls
      id={data?.id}
      isAssignees={isAssignees}
      onRemove={() => onRemove(data?.entityId || '')}
      onView={onView}
    />
  );

  return (
    <Grid
      container
      spacing={3}
      alignItems="center"
    >
      <Grid
        item
        xs={9}
        sm={5}
      >
        <MemberDetails
          hideAvatarOnSmallScreen
          data={data?.createdBy}
          title={data?.name}
          subtitle={`${ data.users?.length } Member${ data.users?.length === 1 ? '' : 's' } ${ isAssignees ? 'Assigned' : 'Tagged' }`}
        />
      </Grid>

      <FlexEndGrid
        item
        xs={3}
        sx={{ display: { sm: 'none' } }}
      >
        { ItemsActions }
      </FlexEndGrid>

      <FlexEndGrid
        item
        xs={12}
        sm={7}
        sx={{ justifyContent: { xs: 'flex-start', sm: 'flex-end' } }}
      >
        <FamilyMembersList
          shifted
          noWrap
          fixed
          justify="flex-end"
          data={filterMembersById(familyMembers, data?.users)}
        />

        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
          { ItemsActions }
        </Box>
      </FlexEndGrid>

      { !last && (
        <GridDivider margin={'10px 0 20px'} />
      ) }
    </Grid>
  );
};
